var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialBgCornerDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H10V10C10 4.47715 5.52285 0 0 0Z",
    fill: "#081B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialBgCornerDown);
export default __webpack_public_path__ + "static/media/tutorialBgCornerDown.0bfa4c1f673f98992b53e2bbbcb1d876.svg";
export { ForwardRef as ReactComponent };